/**
 * Exposes past performances from pastPerformancesStore for website preview components.
 * When there are none, returns 3 dummy placeholders.
 */

import { useEffect } from "react";
import { usePastPerformancesStore } from "@/stores/pastPerformancesStore";
import type { PastPerformanceApiItem } from "@/services/artistService";

const DUMMY_PAST_PERFORMANCES: PastPerformanceApiItem[] = [
  { id: -1, event_count: 0, event_type: 0, event_name: "Event #1", desc: "Description #1" },
  { id: -2, event_count: 0, event_type: 0, event_name: "Event #2", desc: "Description #2" },
  { id: -3, event_count: 0, event_type: 0, event_name: "Event #3", desc: "Description #3" },
];

export function usePastPerformancesForPreview() {
  const data = usePastPerformancesStore((s) => s.data);
  const ensureFetched = usePastPerformancesStore((s) => s.ensureFetched);

  useEffect(() => {
    ensureFetched();
  }, [ensureFetched]);

  const raw = data ?? [];
  const performances = raw.length > 0 ? raw : DUMMY_PAST_PERFORMANCES;

  return {
    performances,
    hasPerformances: raw.length > 0,
  };
}
